import React, { Component } from 'react';
import '../../assets/css/common.css'
import { searchAPI } from "../../api/aboutus.js";
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'
import './index.css'
class AboutUs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			aboutus: '',
			contactus: '',
		};
	}


	componentDidMount() {
		this.ajaxData();
	}

	// 获取表格数据
	ajaxData = () => {
		searchAPI().then((res) => {
			var data = res.data.data
			this.setState({ aboutus: data.aboutus, contactus: data.contactus });
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0;
		});
	};

	render() {
		const { aboutus, contactus } = this.state;
		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{ url: '/aboutus', breadcrumbName: '关于我们' },
				]} />
				{/* 关于我们 */}
				<div className="major-heading module-title" style={{ textAlign: 'left', marginTop: 10, color: '#144db9' }}>关于我们</div>
				<div className="auxiliary-text module-subtitle">ABOUT US</div>
				<div dangerouslySetInnerHTML={{ __html: aboutus }}></div>


				{/* 联系我们 */}
				<div className="major-heading" style={{ textAlign: 'left', marginTop: 60, color: '#144db9' }}>联系我们</div>
				<div className="auxiliary-text module-subtitle">CONTACT US</div>
				<div dangerouslySetInnerHTML={{ __html: contactus }}></div>

			</div>
		);
	}
}

export default AboutUs
